module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.add-to-unscopables.js
// module id = 297
// module chunks = 174 178 179 193 194 195